module.exports = __webpack_public_path__ + "img/insurance-companies.514c4e46.svg";